export default "__VITE_ASSET__CgzgIlh7__"